<template>
  <div class="test">
    <img class="image" src="@/assets/family/jingci/1.jpg" alt="">
    <Sticky></Sticky>
    <!-- <img class="image" src="@/assets/family/kangxin/kangxin3.png" alt=""> -->
  </div>
</template>

<script>
import Sticky from '@/components/sticky.vue'
export default {
  name: 'test',
  components:{ 
    Sticky
  },
  data() {
    return {
    }
  },
  computed:{ },
  watch:{ },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.test {
  max-width: 1920px;
  .image {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
  }
}
</style>